<template>
  <div :class="$style.invoiceRecord">
    <!-- 头部区域 -->
    <div :class="$style.header">
      <h2 :class="$style.title">发票流水记录</h2>

      <InvoiceStats :stats="stats" :loading="statsLoading" />

      <div :class="$style.searchPanel">
        <div :class="$style.searchLeft">
          <el-select v-model="searchArr.buyer_company" filterable remote reserve-keyword placeholder="请输入购方企业名称"
            size="mini" clearable :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"
            @change="handleSearchCompanyChange">
            <el-option v-for="searchCompany in searchBuyerCompany" :key="searchCompany.id"
              :label="searchCompany.buyer_company" :value="searchCompany.buyer_company">
            </el-option>
          </el-select>

          <el-popover placement="bottom-start" v-model="visible" width="450">
            <el-form :model="searchArr" ref="searchForm" label-width="100px">
              <el-form-item label="购方税号" prop="buyer_taxnum">
                <el-input v-model="searchArr.buyer_taxnum" size="mini" placeholder="购方税号"></el-input>
              </el-form-item>
              <el-form-item label="是否绑定" prop="binded">
                <el-checkbox-group v-model="searchArr.binded">
                  <el-checkbox false-label="" true-label="1" name="binded">已绑定</el-checkbox>
                  <el-checkbox false-label="" true-label="2" name="binded">未绑定</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="发票状态" prop="invoice_status">
                <el-select v-model="searchArr.invoice_status" multiple filterable placeholder="请选择发票状态"
                  :loading="invoice_status_loading" @click.native="get_invoice_status" size="mini" style="width: 100%;">
                  <el-option label="没有发票状态" value="__none__"></el-option>
                  <el-option v-for="item in InvoiceStatusOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开票日期" prop="invoice_date">
                <el-date-picker v-model="searchArr.invoice_date" type="daterange" range-separator="至" size="mini"
                  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="pickerSuccessTimeDateChange"
                  start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm()" size="mini">查询</el-button>
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini" :class="$style.filterBtn">筛选</el-button>
          </el-popover>
        </div>

        <div :class="$style.searchRight">
          <el-upload :http-request="upload" :headers="uploadHeader" :show-file-list="false" accept=".xlsx,.xls,.csv"
            :before-upload="beforeFileUpload" action="">
            <el-button type="primary" size="mini" :class="$style.importBtn">
              <i class="el-icon-upload"></i>导入
            </el-button>
          </el-upload>
          <!-- <el-upload :action="actionHost + '/api/admin/invoice_record/import'" :headers="uploadHeader"
            :show-file-list="false" :on-success="handleImport">
            <el-button type="primary" size="mini" :class="$style.importBtn">
              <i class="el-icon-upload"></i>导入
            </el-button>
          </el-upload> -->
        </div>
      </div>
    </div>

    <!-- 主体内容区域 -->
    <div :class="$style.content">
      <el-table :class="$style.table" :data="invoiceRecords" size="medium" border v-cloak
        :max-height="tableMaxHeight + 'px'" ref="invoiceTable">
        <!-- 1. 发票代码 -->
        <el-table-column label="发票代码" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_code">
              <span :class="$style.cellText">{{ scope.row.invoice_code }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 2. 发票号码 -->
        <el-table-column label="发票号码" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.incoice_num">
              <span :class="$style.cellText">{{ scope.row.incoice_num }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 3. 数电发票号码 -->
        <el-table-column label="数电发票号码" width="190">
          <template slot-scope="scope">
            <div v-if="scope.row.e_incoice_num">
              <span :class="$style.cellText">{{ scope.row.e_incoice_num }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 4. 销方识别号 -->
        <el-table-column label="销方识别号" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.seller_taxnum">
              <el-tooltip :content="scope.row.seller_taxnum" placement="top">
                <span :class="$style.cellText">{{ scope.row.seller_taxnum }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 5. 销方名称 -->
        <el-table-column label="销方名称" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.seller_company">
              <el-tooltip :content="scope.row.seller_company" placement="top">
                <span :class="$style.cellText">{{ scope.row.seller_company }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 6. 购方识别号 -->
        <el-table-column label="购方识别号" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.buyer_taxnum">
              <el-tooltip :content="scope.row.buyer_taxnum" placement="top">
                <span :class="$style.cellText">{{ scope.row.buyer_taxnum }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 7. 购买方名称 -->
        <el-table-column label="购买方名称" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.buyer_company">
              <el-tooltip :content="scope.row.buyer_company" placement="top">
                <span :class="$style.cellText">{{ scope.row.buyer_company }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 8. 开票日期 -->
        <el-table-column label="开票日期" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_date">
              <span :class="$style.cellText">
                <date-formatter :date-value="scope.row.invoice_date"></date-formatter>
              </span>
            </div>
          </template>
        </el-table-column>

        <!-- 9. 税收分类编码 -->
        <el-table-column label="税收分类编码" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.tax_cate_code">
              <el-tooltip :content="scope.row.tax_cate_code" placement="top">
                <span :class="$style.cellText">{{ scope.row.tax_cate_code }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 10. 特定业务类型 -->
        <el-table-column label="特定业务类型" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.special_business_type">
              <span :class="$style.cellText">{{ scope.row.special_business_type }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 11. 货物或应税劳务名称 -->
        <el-table-column label="货物或应税劳务名称" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.goods_name">
              <el-tooltip :content="scope.row.goods_name" placement="top">
                <span :class="$style.cellText">{{ scope.row.goods_name }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 12. 规格型号 -->
        <el-table-column label="规格型号" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.spec_value">
              <el-tooltip :content="scope.row.spec_value" placement="top">
                <span :class="$style.cellText">{{ scope.row.spec_value }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 13. 单位 -->
        <el-table-column label="单位" width="60">
          <template slot-scope="scope">
            <div v-if="scope.row.unit">
              <span :class="$style.cellText">{{ scope.row.unit }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 14. 数量 -->
        <el-table-column label="数量" width="60">
          <template slot-scope="scope">
            <div v-if="scope.row.number === 1">
              <span :class="$style.cellText">{{ scope.row.number }}</span>
            </div>
            <div v-else>
              <span :class="[$style.cellText, $style.redText]">红冲</span>
            </div>
          </template>
        </el-table-column>

        <!-- 15. 单价 -->
        <el-table-column label="单价" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.price">
              <span :class="$style.cellText">{{ scope.row.price }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 16. 金额 -->
        <el-table-column label="金额" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.amount">
              <span :class="$style.cellText">{{ scope.row.amount }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 17. 税率 -->
        <el-table-column label="税率" width="60">
          <template slot-scope="scope">
            <div v-if="scope.row.tax_rate">
              <span :class="$style.cellText">{{ scope.row.tax_rate }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 18. 税额 -->
        <el-table-column label="税额" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.tax_limit">
              <span :class="$style.cellText">{{ scope.row.tax_limit }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 19. 价税合计 -->
        <el-table-column label="价税合计" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.total_amount">
              <span :class="$style.cellText">{{ scope.row.total_amount }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 20. 发票来源 -->
        <el-table-column label="发票来源" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_source">
              <span :class="$style.cellText">{{ scope.row.invoice_source }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 21. 发票票种 -->
        <el-table-column label="发票票种" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_type">
              <span :class="$style.cellText">{{ scope.row.invoice_type }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 22. 发票状态 -->
        <el-table-column label="发票状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_status">
              <span :class="$style.cellText">{{ scope.row.invoice_status }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 23. 是否正数发票 -->
        <el-table-column label="是否正数发票" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.is_positive">
              <span :class="$style.cellText">{{ scope.row.is_positive }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 24. 发票风险等级 -->
        <el-table-column label="发票风险等级" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.risk_level">
              <span :class="$style.cellText">{{ scope.row.risk_level }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 25. 开票人 -->
        <el-table-column label="开票人" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.drawer">
              <span :class="$style.cellText">{{ scope.row.drawer }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 26. 备注 -->
        <el-table-column label="备注" min-width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.remark">
              <el-tooltip :content="scope.row.remark" placement="top">
                <span :class="$style.cellText">{{ scope.row.remark }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>


    </div>

    <!-- 底部区域 -->
    <div :class="$style.footer">
      <el-pagination background :class="$style.pagination" layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DateFormatter from "common/DateFormatter";
import InvoiceStats from "./components/InvoiceStats.vue"
import { hyperfHost } from '@/YsyCollections/host/hyperfHost.js'

export default {
  name: 'InvoiceRecord',
  components: { DateFormatter, InvoiceStats },
  data() {
    return {
      searchArr: {
        buyer_company: '',
        buyer_taxnum: '',
        invoice_date: '',
        transfer_start_time: '',
        transfer_end_time: '',
        binded: '',
        invoice_status: ''
      },
      searchLoading: false,
      invoiceRecords: [],
      searchBuyerCompany: [],
      visible: false,
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30
      },
      uploadHeader: { Authorization: localStorage.token },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: picker => {
              picker.$emit('pick', [new Date(), new Date()])
            }
          },
          {
            text: '昨天',
            onClick: picker => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [date, date])
            }
          },
          {
            text: '本周',
            onClick: picker => {
              picker.$emit('pick', [this.thisWeek()[0], this.thisWeek()[1]])
            }
          },
          {
            text: '上周',
            onClick: picker => {
              picker.$emit('pick', [this.LastWeek()[0], this.LastWeek()[1]])
            }
          },
          {
            text: '本月',
            onClick: picker => {
              picker.$emit('pick', [this.thisMonth()[0], this.thisMonth()[1]])
            }
          },
          {
            text: '上个月',
            onClick: picker => {
              picker.$emit('pick', [this.LastMonth()[0], this.LastMonth()[1]])
            }
          }
        ]
      },
      stats: {},
      statsLoading: false,
      tableMaxHeight: 0,
      isUploading: false,
      invoice_status_loading: false,
      InvoiceStatusOptions: []
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {
    getInvoiceRecords() {
      this.statsLoading = true
      this.$axios
        .get(
          '/api/admin/invoice_record/index?page=' +
          this.pageOption.currentPage +
          "&pageSize=" +
          this.pageOption.pageSize + this.searchStr
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.invoiceRecords = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
            this.stats = data.data.formattedStats || {}
          }
        })
        .finally(() => {
          this.statsLoading = false
        })
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
      this.getInvoiceRecords()
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.getInvoiceRecords()
    },
    searchRemoteCompanyMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchBuyerCompany = []
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get('/api/admin/search_buyer_company?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchBuyerCompany = data.data.searchBuyerCompany
        }
      })
    },
    resetForm(formName) {
      this.visible = false
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getInvoiceRecords()
    },
    submitForm() {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getInvoiceRecords()
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1
      this.getInvoiceRecords()
    },
    handleImport(res, file) {
      if (res.code === 0) {
        this.$message.success(res.msg)
        this.getInvoiceRecords()
      }
    },
    pickerSuccessTimeDateChange(val) {
      if (!val) {
        this.searchArr.transfer_start_time = []
        this.searchArr.transfer_end_time = []
      } else {
        this.searchArr.transfer_start_time = val[0]
        this.searchArr.transfer_end_time = val[1]
      }
    },
    LastWeek() {
      const end = new Date()
      const start = new Date()
      const lastWeek = new Date().getDay()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1))
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek)
      return [start, end]
    },
    thisWeek() {
      var Nowdate = new Date()
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000)

      var M = Number(WeekFirstDay.getMonth()) + 1
      var start =
        WeekFirstDay.getFullYear() + '-' + M + '-' + WeekFirstDay.getDate()

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000)
      var Mon = Number(WeekLastDay.getMonth()) + 1
      var end =
        WeekLastDay.getFullYear() + '-' + Mon + '-' + WeekLastDay.getDate()

      return [start, end]
    },
    thisMonth() {
      const end = new Date()
      const start = new Date()
      const endDay = new Date().getDate() - 1
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay)
      return [start, end]
    },
    LastMonth() {
      const end = new Date()
      const start = new Date()
      const year = new Date().getFullYear()
      let month = new Date().getMonth()
      month = month === 0 ? 1 : month
      const febDays = year % 4 ? 29 : 28
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      start.setDate(1 - days[month - 1])
      end.setDate(1 - 1)
      return [start, end]
    },
    calcTableMaxHeight() {
      const invoiceRecordEl = document.querySelector(`.${this.$style.invoiceRecord}`);
      const headerEl = document.querySelector(`.${this.$style.header}`);
      const footerEl = document.querySelector(`.${this.$style.footer}`);

      if (!invoiceRecordEl || !headerEl || !footerEl) {
        this.tableMaxHeight = 500; // 默认高度兜底
        return;
      }

      // 计算逻辑不变（结果是纯数字，比如500）
      const totalHeight = invoiceRecordEl.offsetHeight;
      const headerHeight = headerEl.offsetHeight;
      const footerHeight = footerEl.offsetHeight;
      const padding = 32;
      this.tableMaxHeight = Math.max(100, Math.floor(totalHeight - headerHeight - footerHeight - padding));
    },
    async upload(param) {
      try {
        const formData = new FormData()
        formData.append('file', param.file)
        const { data } = await this.$axios.post(`${hyperfHost}qyh/invoice_record/upload`,
          formData
        )
        if (data.code === 0) {
          const { taskId, fileName } = data.data
          this.$bus.$emit('invoice:import:start', {
            taskId,
            fileName
          })
          this.$message.success(data.msg)
        } else {
          throw new Error(data.msg || '导入失败')
        }
      } catch (err) {
        this.$message.error(err.message || '导入失败')
      } finally {
        this.isUploading = false
      }
    },
    beforeFileUpload(file) {
      const isExcel = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('请上传Excel或Csv文件（.xlsx/.xls/.csv）！')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB！')
        return false
      }

      this.isUploading = true
      return true
    },
    async get_invoice_status() {
      try {
        this.invoice_status_loading = true
        const { data } = await this.$axios.get(`${hyperfHost}qyh/invoice_record/getInvoiceStatus`);
        if (data.code == 0) {
          this.InvoiceStatusOptions = data.data
        }
      } catch (err) {

      } finally {
        this.invoice_status_loading = false
      }
    }
  },
  mounted() {
    this.getInvoiceRecords()
    this.$nextTick(() => {
      this.calcTableMaxHeight();
      if (this.$refs.invoiceTable) {
        this.$refs.invoiceTable.doLayout();
      }
    });
    // 窗口 resize 时重新计算高度
    window.addEventListener('resize', this.calcTableMaxHeight);
  },
  beforeDestroy() {
    // 移除监听，避免内存泄漏
    window.removeEventListener('resize', this.calcTableMaxHeight);
  },
}
</script>

<style module>
.invoiceRecord {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  height: 100vh;
  box-sizing: border-box;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.header {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.title {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #e6ebf5;
  padding-bottom: 15px;
}

.searchPanel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.searchLeft {
  display: flex;
  align-items: center;
  gap: 12px;
}

.searchLeft :global(.el-select) {
  width: 270px;
}

.searchLeft :global(.el-select .el-input__inner) {
  border-radius: 4px;
}

.filterBtn {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background: #fff;
}

.filterBtn:hover {
  border-color: #c0c4cc;
  color: #606266;
}

.importBtn {
  border-radius: 4px;
}

.importBtn i {
  margin-right: 5px;
}

.content {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-x: auto;
  padding: 0 1px;
}

.table {
  border: none;
  width: auto !important;
  min-width: fit-content;
  overflow: auto;
  /* flex: 1; */
}

.table :global(.el-table__header-wrapper) {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  /* overflow-y: auto !important; */
  /* overflow: auto; */
}

.table :global(.el-table__body-wrapper) {
  /* 删：去掉 overflow-y: auto !important（表格 scroll 属性会自动加） */
  scrollbar-width: thin;
  /* 保留：优化滚动条样式（可选） */
}

.table :global(.el-table .cell) {
  white-space: nowrap;
}

.table :global(.el-table__header),
.table :global(.el-table__body) {
  width: 100% !important;
}

.table :global(.el-table__header th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.table :global(.el-table__body tr:hover > td) {
  background-color: #f5f7fa;
}

.cellText {
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.redText {
  color: #f56c6c;
  font-weight: 500;
}

.footer {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.pagination :global(.btn-prev),
.pagination :global(.btn-next),
.pagination :global(.el-pager li) {
  border-radius: 4px;
  margin: 0 3px;
}

/* v-cloak 指令样式 */
[v-cloak] {
  display: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .searchPanel {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .searchRight {
    align-self: flex-end;
  }

  .content {
    overflow-x: auto;
  }

  .table {
    min-width: 1200px;
    /* 确保表格有最小宽度，在小屏幕上可以横向滚动 */
  }
}

@media (max-width: 768px) {
  .invoiceRecord {
    padding: 1.2rem 0.2rem 0.2rem 0.2rem;
  }

  .header {
    padding: 15px;
  }

  .title {
    font-size: 18px;
  }

  .searchLeft {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .searchLeft :global(.el-select) {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/invoice_record/InvoiceRecord.vue